import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Garantie() {
  const { t } = useTranslation('apropos');
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.1);

  return (
    <section id="garantie" className="bg-white py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          ref={ref}
          className={`bg-slate-primary rounded-xl p-8 md:p-12 text-center transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="w-16 h-16 flex items-center justify-center rounded-full bg-copper/20 mx-auto mb-6">
            <i className="ri-file-shield-line text-copper text-2xl" />
          </div>
          <h2 className="font-manrope font-bold text-white text-2xl md:text-3xl mb-5">
            {t('garantie_h2')}
          </h2>
          <p className="text-white/80 text-sm md:text-base leading-relaxed">
            {t('garantie_text')}
          </p>
        </div>
      </div>
    </section>
  );
}